export const red = `linear-gradient(
    178.89deg,
    #db2e2e 14.22%,
    #e43030 36.3%,
    #f84444 99.05%
  )`
export const blue = `linear-gradient(178.89deg, #1F3DB6 14.22%, #2345CA 36.3%, #355AEE 99.05%);`
